import React from "react";
import "../styles/detailBlock.scss";
import LabelText from "./LabelText";

export default function DetailBlock({
  children,
  style,
  left,
  middle,
  right,
  title,
}) {
  return (
    <div style={style} className="detail-block">
      <div className="top">
        <div>
          {title && (
            <div className="title">
              <LabelText label={title} />
            </div>
          )}
          {left}
        </div>
        <div>{middle}</div>
        <div className="right">{right}</div>
      </div>
      {children}
    </div>
  );
}
